export default __webpack_public_path__ + "a7c6d60e6dc2faecea92b669618c8b24.svg";